/**
Author - Kaustubh Mishra
Git - git@github.com:KaustubhMishra25
**/

import ArnCardUpload from "./ArnCardUpload.container";

export default ArnCardUpload;